"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Layout_1 = require("../../components/Layout");
var styles_1 = require("./styles");
var Project = function (_a) {
    var websiteUrl = _a.websiteUrl, pictureSrc = _a.pictureSrc, title = _a.title, subTitle = _a.subTitle;
    return (react_1.default.createElement(styles_1.Link, { href: websiteUrl, target: "_blank" },
        react_1.default.createElement(styles_1.Picture, { src: pictureSrc, alt: title }),
        react_1.default.createElement(Layout_1.Overlay, null,
            react_1.default.createElement(styles_1.PictureTitle, null, title),
            react_1.default.createElement(styles_1.PictureSubTite, null, subTitle))));
};
exports.default = Project;
